var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex home justify-content-center"},[_c('Reports')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }